<div class="eidos-confirmation-dialog">
  <h1 class="eidos-confirmation-dialog-title">{{ title }}</h1>
  <div class="eidos-confirmation-dialog-content">
    {{ message }}
  </div>
  <div class="eidos-confirmation-dialog-actions">
    <button class="eidos-button eidos-button-normal eidos-button-cancel" type="button" (click)="cancel()">{{ cancelLabel }}</button>
    <button class="eidos-button eidos-button-normal eidos-button-success" type="button" (click)="confirm()">{{ confirmationLabel }}</button>
  </div>
</div>
